// extracted by css-extract-rspack-plugin
export default {"heading":"heading-QEIcpG"};